import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as cafeEventsActions from '../../../redux/cafeEvents/actions';
import * as cafeActions from '../../../redux/cafes/actions';
import ArchivedCafeEventsTable from './archivedCafeEventsTable';
import ArchivedCafeEventsFilter from './archivedCafeEventsFilter';
import Spin from '../../../components/loading';
import Pagination2 from '../../../components/Pagination2';
import submitForm from '../../../utils/submitForm';

class ArchivedCafeEvents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      sortType: 'asc',
      sortBy: 'fromDate',
      cafeIds: [],
      itemsPerPage: 10
    };
  }

  componentDidMount() {
    this.sortTable(this.state.sortBy);
    this.props.actions.getAllCafeNamesForPanel();
  }

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.actions.fetchAllArchivedCafeEvents(query);
    });
  };

  sortTable = query => {
    this.setState({ sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  applyFilters = event => {
    const queryString = submitForm(event, [], [], this.state.cafeIds);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.actions.fetchAllArchivedCafeEvents(searchQuery);
    });
  };

  onSelectCafeIds = cafeIds => this.setState({ cafeIds: cafeIds ? [...cafeIds] : [] });

  render() {
    let {
      archivedCafeEventsLoading,
      archivedCafeEventsMessage,
      archivedCafeEventsFailed,
      archivedCafeEventsError
    } = this.props;
    let { totalRecords } = this.props.archivedCafeEvents;
    let { currentPage, itemsPerPage } = this.state;
    return (
      <>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">
            <div className="text-right">{locales('titles.archivedCafeEvents')}</div>
          </h3>
        </div>
        <section className="p-1 col-12">
          <Spin spinning={archivedCafeEventsLoading}>
            <article>
              <main className="panel panel-default">
                {archivedCafeEventsError ? (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                ) : (
                  <>
                    {archivedCafeEventsFailed && (
                      <div className="alert alert-danger">{archivedCafeEventsMessage}</div>
                    )}
                    <div className="panel-heading">
                      <i className="fas fa-list-alt px-1" />
                      {locales('titles.archivedCafeEventsList')}
                    </div>
                    <div className="panel-body">
                      <ArchivedCafeEventsFilter
                        applyFilters={this.applyFilters}
                        onSelectCafeIds={this.onSelectCafeIds}
                        filterAndSort={this.filterAndSort}
                        cafeNamesList={this.props.cafeNamesList}
                      />
                      <ArchivedCafeEventsTable
                        pageNumber={currentPage}
                        sortTable={this.sortTable}
                        buildSearchQuery={this.buildSearchQuery}
                        pageSize={itemsPerPage}
                        sortType={this.state.sortType}
                      />
                      <footer className="col-12 d-flex justify-content-center py-2">
                        <div className="pagination-container">
                          <Pagination2
                            totalRecords={totalRecords || 0}
                            pageLimit={itemsPerPage}
                            pageNeighbours={2}
                            onPageChanged={this.onPageChanged}
                            currentPage={this.state.currentPage}
                          />
                        </div>
                      </footer>
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    archivedCafeEventsList: state.cafeEventsReducer.archivedCafeEventsList,
    archivedCafeEvents: state.cafeEventsReducer.archivedCafeEvents,
    archivedCafeEventsLoading: state.cafeEventsReducer.archivedCafeEventsLoading,
    archivedCafeEventsMessage: state.cafeEventsReducer.archivedCafeEventsMessage,
    archivedCafeEventsFailed: state.cafeEventsReducer.archivedCafeEventsFailed,
    archivedCafeEventsError: state.cafeEventsReducer.archivedCafeEventsError,

    cafeNamesLoading: state.cafesReducer.cafeNamesLoading,
    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNamest: state.cafesReducer.cafeNames,
    cafeNamesFailed: state.cafesReducer.cafeNamesFailed,
    cafeNamesMessage: state.cafesReducer.cafeNamesMessage,
    cafeNamesError: state.cafesReducer.cafeNamesError,

    cafeNamesListLoading: state.cafesReducer.cafeNamesListLoading,
    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNamesListFailed: state.cafesReducer.cafeNamesListFailed,
    cafeNamesListMessage: state.cafesReducer.cafeNamesListMessage,
    cafeNamesListError: state.cafesReducer.cafeNamesListError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      fetchAllArchivedCafeEvents: query => dispatch(cafeEventsActions.fetchAllArchivedCafeEvents(query)),
      getAllCafeNamesForPanel: () => dispatch(cafeActions.getAllCafeNamesForPanel())
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ArchivedCafeEvents));
